import { ViewModel,View } from "binder"
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import  { InterfacePersonSearchView } from "./interfacePersonSearch-view"

export class InterfacePersonSearchViewModel extends SearchableSelectorBaseViewModel<InterfacePersonForSelector>{
    constructor(parentViewModel: ViewModel, customerId?:string) {
        super(parentViewModel);
        this.customerId = customerId;
    }

    GetDefaultView(): View <ViewModel> {
        return new InterfacePersonSearchView();
    }
    public getTypeId(): string {
        return "VM-1A07D91E-6306-478B-94DD-F1EC5D2C7266"
    }

    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    
    protected async loadData(searchedText: string): Promise<InterfacePersonForSelector[]> {
        let result = await ServerConnection.callServer('Complex/CrmServices/SearchInterfacePersons',{
            CustomerId: this.customerId,
            SearchText:searchedText,
            ResultCount:20,
        });
        return result.InterfacePersons.map(x=>this.convertSingle(x));
    }
    protected async loadById(id: string): Promise<InterfacePersonForSelector> {
        let result = await ServerConnection.callServer('Complex/CrmServices/SearchInterfacePersonsById',{
            Id:id
        });    
        return this.convertSingle(result.InterfacePerson);
    }
    
    private convertSingle(dto:any):InterfacePersonForSelector{
        var p = new InterfacePersonForSelector(this);
        p.id = dto.Id;
        p.comment = dto.Comment;
        p.name = dto.FirstName;
        p.lastName = dto.LastName;
        p.phone = dto.Phone;
        p.title = dto.FullName;
        return p;
    }
}


export class InterfacePersonSelectorByCustomerViewModel extends SelectorBaseViewModel<InterfacePersonForSelector>{
    constructor(parentViewModel: ViewModel, customerId?:string) {
        super(parentViewModel,true);
        this.customerId = customerId;
        this.refresh();
    }

    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    
    protected async loadData(): Promise<InterfacePersonForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/CrmServices/GetAllInterfacePersonsByCustomer',{
            CustomerId: this.customerId
        });
        return result.InterfacePersons.map(q=>{
            let result = new InterfacePersonForSelector(this);
            result.id = q.Id;
            result.title = q.FullName;
            result.name = q.FirstName;
            result.lastName = q.LastName;
            result.phone = q.Phone;
            result.comment = q.Comment;
            return result;
        });
    }

}

export class InterfacePersonForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set lastName(v: string) { this._lastName = v; } public get lastName(): string { return this._lastName;} private _lastName: string;
    public set phone(v: string) { this._phone = v; } public get phone(): string { return this._phone;} private _phone: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
}